const execCommand = function (scribe, command) {
  let [methodName, ...methodArgs] = command;
  scribe[methodName](...methodArgs);
};

const readQueue = function (scribe, queue) {
  queue.forEach(function (command) {
    execCommand(scribe, command);
  });
};

export { readQueue };
